export default __webpack_public_path__ + "static/b55909f4c07f8226c97ff7b35bf3ebf4.mp3";